import React, { useMemo } from "react";

import { StyleSheet, View, Text, TouchableOpacity, Image } from "react-native";
import { getCityCountryString } from "../../../../../helpers";
import { Colors, Constants, Fonts, Images } from "../../../../config";
import { CImage } from "../../../atoms";

const LocationBar = (props) => {
  const { category, address, postcode, venue, street, isMobileVersion } = props;
  const isVenueShow = venue != undefined && venue != "";
  const isAddressShow = street != undefined && street != "";
  const cityCountryString = useMemo(
    () => getCityCountryString(props.city, props.country),
    [props.city, props.country]
  );
  return (
    <View
      style={[
        styles.container,
        isMobileVersion
          ? {
              height: "auto",
              paddingTop: 12,
              paddingBottom: 4,
              paddingHorizontal: 12,
            }
          : {},
      ]}>
      {isAddressShow && (
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginRight: 10,
            marginBottom: isMobileVersion ? 8 : 0,
          }}>
          <CImage
            source={Images.iconLocationPin}
            width={isMobileVersion ? 14 : 20}
            height={isMobileVersion ? 14 : 20}
            layout={"fixed"}
            objectFit="contain"
            className={
              category === Constants.categoryType.CATEGORY_ROOFTOP ||
              category === Constants.categoryType.CATEGORY_PARKFUL
                ? "img-drop-shadow"
                : ""
            }
          />
          <Text
            style={[
              styles.text,
              isMobileVersion
                ? { fontSize: 10, lineHeight: 12, marginLeft: 6 }
                : {},
            ]}>
            <address style={{ fontStyle: "normal" }}>
              {street +
                (postcode !== "" && postcode !== null && postcode !== undefined
                  ? ", " + postcode
                  : "")}
            </address>
          </Text>
        </View>
      )}

      {isVenueShow && (
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginRight: 10,
            marginBottom: isMobileVersion ? 8 : 0,
          }}>
          <CImage
            source={
              category === Constants.categoryType.CATEGORY_ROOFTOP ||
              category === Constants.categoryType.CATEGORY_VENUE_COCKTAIL ||
              category === Constants.categoryType.CATEGORY_VENUE_BEACHFUL ||
              category === Constants.categoryType.CATEGORY_PREFAB_COMPANY ||
              category === Constants.categoryType.CATEGORY_PREFAB_HOMES ||
              category === Constants.categoryType.CATEGORY_ZOO ||
              category === Constants.categoryType.CATEGORY_ANIMAL ||
              category === Constants.categoryType.CATEGORY_PARKFUL ||
              category === Constants.categoryType.CATEGORY_CASINO ||
              category === Constants.categoryType.CATEGORY_CASTLE ||
              category === Constants.categoryType.CATEGORY_RESORT ||
              category === Constants.categoryType.CATEGORY_APARTHOTEL ||
              category === Constants.categoryType.CATEGORY_SPA
                ? Images.iconTagGeneral
                : Images.iconTagVenue
            }
            width={
              isMobileVersion
                ? category === Constants.categoryType.CATEGORY_ROOFTOP ||
                  category === Constants.categoryType.CATEGORY_VENUE_COCKTAIL ||
                  category === Constants.categoryType.CATEGORY_VENUE_BEACHFUL ||
                  category === Constants.categoryType.CATEGORY_PREFAB_COMPANY ||
                  category === Constants.categoryType.CATEGORY_PREFAB_HOMES ||
                  category === Constants.categoryType.CATEGORY_ZOO ||
                  category === Constants.categoryType.CATEGORY_ANIMAL ||
                  category === Constants.categoryType.CATEGORY_PARKFUL ||
                  category === Constants.categoryType.CATEGORY_CASINO ||
                  category === Constants.categoryType.CATEGORY_CASTLE ||
                  category === Constants.categoryType.CATEGORY_RESORT ||
                  category === Constants.categoryType.CATEGORY_APARTHOTEL ||
                  category === Constants.categoryType.CATEGORY_SPA
                  ? 14
                  : 14
                : category === Constants.categoryType.CATEGORY_ROOFTOP ||
                  category === Constants.categoryType.CATEGORY_VENUE_COCKTAIL ||
                  category === Constants.categoryType.CATEGORY_VENUE_BEACHFUL ||
                  category === Constants.categoryType.CATEGORY_PREFAB_COMPANY ||
                  category === Constants.categoryType.CATEGORY_PREFAB_HOMES ||
                  category === Constants.categoryType.CATEGORY_ZOO ||
                  category === Constants.categoryType.CATEGORY_ANIMAL ||
                  category === Constants.categoryType.CATEGORY_PARKFUL ||
                  category === Constants.categoryType.CATEGORY_CASINO ||
                  category === Constants.categoryType.CATEGORY_CASTLE ||
                  category === Constants.categoryType.CATEGORY_RESORT ||
                  category === Constants.categoryType.CATEGORY_APARTHOTEL ||
                  category === Constants.categoryType.CATEGORY_SPA
                ? 20
                : 20
            }
            height={
              isMobileVersion
                ? category === Constants.categoryType.CATEGORY_ROOFTOP ||
                  category === Constants.categoryType.CATEGORY_VENUE_COCKTAIL ||
                  category === Constants.categoryType.CATEGORY_VENUE_BEACHFUL ||
                  category === Constants.categoryType.CATEGORY_PREFAB_COMPANY ||
                  category === Constants.categoryType.CATEGORY_PREFAB_HOMES ||
                  category === Constants.categoryType.CATEGORY_ZOO ||
                  category === Constants.categoryType.CATEGORY_ANIMAL ||
                  category === Constants.categoryType.CATEGORY_PARKFUL ||
                  category === Constants.categoryType.CATEGORY_CASINO ||
                  category === Constants.categoryType.CATEGORY_CASTLE ||
                  category === Constants.categoryType.CATEGORY_RESORT ||
                  category === Constants.categoryType.CATEGORY_APARTHOTEL ||
                  category === Constants.categoryType.CATEGORY_SPA
                  ? 14
                  : 14
                : category === Constants.categoryType.CATEGORY_ROOFTOP ||
                  category === Constants.categoryType.CATEGORY_VENUE_COCKTAIL ||
                  category === Constants.categoryType.CATEGORY_VENUE_BEACHFUL ||
                  category === Constants.categoryType.CATEGORY_PREFAB_COMPANY ||
                  category === Constants.categoryType.CATEGORY_PREFAB_HOMES ||
                  category === Constants.categoryType.CATEGORY_ZOO ||
                  category === Constants.categoryType.CATEGORY_ANIMAL ||
                  category === Constants.categoryType.CATEGORY_PARKFUL ||
                  category === Constants.categoryType.CATEGORY_CASINO ||
                  category === Constants.categoryType.CATEGORY_CASTLE ||
                  category === Constants.categoryType.CATEGORY_RESORT ||
                  category === Constants.categoryType.CATEGORY_APARTHOTEL ||
                  category === Constants.categoryType.CATEGORY_SPA
                ? 20
                : 20
            }
            layout={"fixed"}
            objectFit="contain"
            className={
              category === Constants.categoryType.CATEGORY_ROOFTOP ||
              category === Constants.categoryType.CATEGORY_PARKFUL
                ? "img-drop-shadow"
                : ""
            }
          />
          <Text
            style={[
              styles.text,
              isMobileVersion
                ? { fontSize: 10, lineHeight: 12, marginLeft: 6 }
                : {},
            ]}>
            <address style={{ fontStyle: "normal" }}>{venue}</address>
          </Text>
        </View>
      )}
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginBottom: isMobileVersion ? 8 : 0,
        }}>
        <CImage
          source={Images.iconWorldwideColored}
          width={isMobileVersion ? 14 : 20}
          height={isMobileVersion ? 14 : 20}
          layout={"fixed"}
          objectFit="contain"
          className={
            category === Constants.categoryType.CATEGORY_ROOFTOP ||
            category === Constants.categoryType.CATEGORY_PARKFUL
              ? "img-drop-shadow"
              : ""
          }
        />
        <Text
          style={[
            styles.text,
            isMobileVersion
              ? { fontSize: 10, lineHeight: 12, marginLeft: 6 }
              : {},
          ]}>
          <address style={{ fontStyle: "normal" }}>{cityCountryString}</address>
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    alignSelf: "stretch",
    paddingHorizontal: 16,
    height: 60,
    flexWrap: "wrap",
  },
  text: {
    fontSize: 16,
    fontFamily: Fonts.primaryMedium,
    lineHeight: 18,
    marginLeft: 10,
    color: Colors.white,
  },
  icon: {
    width: 14,
    height: 14,
  },
});

export default LocationBar;
